import { useCallback, useContext, useEffect, useState } from 'react';

import { WARNING } from '@app/constants';
import { NotificationContext } from '@app/providers';
import { useLazyPrepareSendoutCreationQuery } from '@app/services/rtkQuery/Sendouts/api';
import type { NSendoutsApi } from '@app/services/rtkQuery/Sendouts/types';

export const usePrepareSendout = (activeBranchId: number) => {
  const { showNotification } = useContext(NotificationContext);
  const [getPrepareSendoutCreation] = useLazyPrepareSendoutCreationQuery();

  const [prepareSendoutCreation, setPrepareSendoutCreation] =
    useState<NSendoutsApi.PrepareSendoutCreationResponse | null>(null);

  const getPrepareSendoutCreationHandler = useCallback(async () => {
    if (!activeBranchId) return;
    try {
      const data = await getPrepareSendoutCreation({
        ActiveBranchId: activeBranchId,
      }).unwrap();
      setPrepareSendoutCreation(data);
    } catch (error) {
      showNotification(error, WARNING);
    }
  }, [activeBranchId, getPrepareSendoutCreation, showNotification]);

  useEffect(() => {
    getPrepareSendoutCreationHandler();
  }, [getPrepareSendoutCreationHandler]);

  return {
    prepareSendoutCreation,
  };
};
